module.exports = __webpack_public_path__ + "img/banner_image01.c812965.jpg";